import React, { useState, useCallback, useContext, createContext } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";

const ConfirmContext = createContext();

export const ConfirmDialogProvider = ({ children }) => {
  const [confirmState, setConfirmState] = useState({
    open: false,
    title: "",
    description: "",
    onConfirm: null,
    confirmLabel: "Yes",
    cancelLabel: "Cancel",
  });

  const confirm = useCallback(
    ({ title, description, confirmLabel = "Yes", cancelLabel = "Cancel" }) => {
      return new Promise((resolve) => {
        setConfirmState({
          open: true,
          title,
          description,
          confirmLabel,
          cancelLabel,
          onConfirm: () => resolve(true),
          onCancel: () => resolve(false),
        });
      });
    },
    []
  );

  const handleClose = () => {
    setConfirmState((prev) => ({ ...prev, open: false }));
  };

  const handleConfirm = () => {
    confirmState.onConfirm?.();
    handleClose();
  };

  const handleCancel = () => {
    confirmState.onCancel?.();
    handleClose();
  };

  return (
    <ConfirmContext.Provider value={confirm}>
      {children}
      <Dialog open={confirmState.open} onClose={handleCancel}>
        <DialogTitle>{confirmState.title}</DialogTitle>
        <DialogContent>
          <Typography>{confirmState.description}</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} variant="outlined">
            {confirmState.cancelLabel}
          </Button>
          <Button onClick={handleConfirm} variant="contained" color="error">
            {confirmState.confirmLabel}
          </Button>
        </DialogActions>
      </Dialog>
    </ConfirmContext.Provider>
  );
};

export const useConfirm = () => {
  return useContext(ConfirmContext);
};
